const LoaderActionTypes = {
    SHOW_LOADER: 'SHOW_LOADER',
    HIDE_LOADER: 'HIDE_LOADER:',
    SHOW_COMPONENT_LOADER: 'SHOW_COMPONENT_LOADER',
    HIDE_COMPONENT_LOADER: 'HIDE_COMPONENT_LOADER:',
};

export default LoaderActionTypes;
